import "core-js/modules/es.array.sort.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["className", "importance", "size", "children", "isAlternative"];
import "core-js/modules/es.array.sort.js";
import React from 'react';
import pt from 'prop-types';
import { Text, BreakpointContext, breakpointPropSwitch } from '..';
import { appendHtmlClass, extendProps, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var HEADING_SIZE_SCALE = getConfig('HEADING_SIZE_SCALE');
var HEADING_SIZE_PREFIX = getConfig('HEADING_SIZE_PREFIX');
var SIZE_OPTIONS = HEADING_SIZE_SCALE.map(function (i) {
  return i.key;
}).sort(function (a, b) {
  return a - b;
});
var Heading = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Heading, _React$Component);
  function Heading() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'h';
    return _this;
  }
  var _proto = Heading.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      importance = _this$props.importance,
      size = _this$props.size,
      children = _this$props.children,
      isAlternative = _this$props.isAlternative,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var el = importance ? "h" + importance : 'div';
    size = this.getResponsiveValue(size);
    className = appendHtmlClass(className, this.DEFAULT_CLASS);
    className = appendHtmlClass(className, "" + HEADING_SIZE_PREFIX + size);
    if (isAlternative) className = appendHtmlClass(className, 'alt');
    return /*#__PURE__*/React.createElement(Text, Object.assign({
      as: el,
      className: className
    }, rest), children);
  };
  return Heading;
}(React.Component);
Heading.contextType = BreakpointContext;
Object.assign(Heading, extendProps(Text, ['align', 'className', 'id', 'color', 'children', 'style'], {
  /**
   * SEO importance h1-h6 or falsy value, which will rendere as div
   */
  importance: pt.oneOf([1, 2, 3, 4, 5, 6]),
  /**
   * Text size
   */
  size: responsivePropType.bind(this, pt.oneOf(HEADING_SIZE_SCALE.map(function (i) {
    return i.key;
  }))),
  /**
   * Alternative style
   */
  isAlternative: pt.bool
}, {
  importance: 6,
  size: SIZE_OPTIONS.length > 0 ? SIZE_OPTIONS[0] : null,
  isAlternative: false
}));
export default Heading;